import {Component, Inject} from '@angular/core';
import {DIALOG_CONFIG, DialogConfig} from 'ac-infra';
import {GroupsActions} from "../../services/actions/groups-actions.service";
import {DateTime} from "luxon";

@Component({
    selector: 'service-commercial-info-dialog',
    templateUrl: './service-commercial-info-dialog.component.html',
    styleUrls: ['./service-commercial-info-dialog.component.less']
})
export class ServiceCommercialInfoDialogComponent {

    formSettings = {valid: true, touched: false};
    commercialInfo: any;
    additionalSettings: any;
    minPocExpiryDate = DateTime.now().startOf('hour').plus({hour: 1});

    commercialInfoSchema = require('../../../../schema/post/commercialinfoprocessor.json');

    constructor(@Inject(DIALOG_CONFIG) public dialogConfig: DialogConfig,
                public groupsActions: GroupsActions) {}

    ngOnInit() {
        this.additionalSettings = this.dialogConfig.dialogData.additionalSettings;
        this.commercialInfo = this.dialogConfig.dialogData.commercialInfo;
        this.approvalChanged();
    }

    approvalChanged = () => {
        this.dialogConfig.submitButtonDisabled = this.additionalSettings.approval === false || this.additionalSettings.fileWasUploaded === false;
    }

    onPocExpiryDateChange(pocExpiryDate: DateTime) {
        if (!pocExpiryDate) {
            return;
        }

        pocExpiryDate = pocExpiryDate.startOf('hour');
        this.additionalSettings.suspendedDate = pocExpiryDate;
        this.commercialInfo.pocExpiryDate = pocExpiryDate ? pocExpiryDate.toUTC().toISO() : null;
    }
}


